import * as React from 'react'
import MaterialTable from '@material-table/core'
import Icon from 'includes/Icons'

export default function BasicTable({ columns, data }) {
  return (
    <MaterialTable
      title=''
      columns={columns}
      options={{
        search: false,
        toolbar: false
      }}
      data={data}
      icons={Icon}
    />
  );
}



